module.exports = __webpack_public_path__ + "img/27.79bf9c7d.jpg";